import DocusaurusFooter from '../DocusaurusFooter'
import {
  Color,
  Paragraph
} from '@eggplant/pattern-library'

const TestConfigGitReferenceInfo = () =>
  <Paragraph>
    <Color variant='theme-description-text'>
      Select the Git reference (branch or tag) for this test config.
      <br />
      Options are configured in the connected Git connection.
      <br />
      To switch branches, ensure the suite structure is the same across branches.
    </Color>
    <DocusaurusFooter path={undefined} />
  </Paragraph>

export default TestConfigGitReferenceInfo